import { Card, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

export default function TroubleshootingStepsCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix:
      'cameraConnectionIssue.cameraConnectionIssueModal.troubleshootingSteps',
  });

  return (
    <Card>
      <Card.Header className="small text-gray-400 fw-semibold text-uppercase">
        {t('header')}
      </Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item>1. {t('checkPower')}</ListGroup.Item>
        <ListGroup.Item>2. {t('checkCable')}</ListGroup.Item>
        <ListGroup.Item>3. {t('checkBattery')}</ListGroup.Item>
        <ListGroup.Item className="d-flex justify-content-between align-items-center">
          <span>4. {t('restartCamera')}</span>
          <span className="text-gray-400 fst-italic small">
            {t('restartCameraDuration')}
          </span>
        </ListGroup.Item>
      </ListGroup>
    </Card>
  );
}
